import groups from './notificationCatalog.json';
import policy from '../../shared/notificationPolicy';
export const NOTIF_GROUPS=groups;
export const NOTIF_TYPES=groups.flatMap(group=>group.types.map(type=>({...type,group:group.label}))).filter(type=>!policy.RAIL_ONLY.has(type.key));
export const NOTIFICATION_PRESETS=policy.PRESETS;
export const notificationContext=policy.contextFor;
export const serializePrefs=policy.storedPreferences;
export const readPrefs=policy.readPreferences;
export const notificationPreferenceKey=policy.keyFor;
export const defaultTypePrefs=()=>({inApp:true,discord:true,push:true});
export const normalizePrefs=(value,context={})=>{
 const stored=serializePrefs(value);
 return {...stored,types:Object.fromEntries(NOTIF_TYPES.map(({key})=>[key,Object.fromEntries(['inApp','push','discord'].map(channel=>[channel,policy.enabled(stored,key,channel,context)]))]))};
};
export const defaultPrefs=()=>normalizePrefs({version:2});
export const isEnabled=(prefs,type,channel)=>prefs?.masterEnabled!==false&&!policy.RAIL_ONLY.has(type)&&prefs?.types?.[notificationPreferenceKey(type)]?.[channel]!==false;
export const overrideChannel=(prefs,type,channel,value,context={})=>normalizePrefs({...serializePrefs(prefs),overrides:{...prefs.overrides,[type]:{...prefs.overrides?.[type],[channel]:value}}},context);
